module.exports = __webpack_public_path__ + "img/cloud1.b6966742.svg";